export default __webpack_public_path__ + "static/media/Maxvit-D-40000-eng.bf0fe831.jpg";